import React from 'react';
import { connect } from 'react-redux';
import { I18nLoader } from '@moka-bo/i18n';
import { initLanguage } from '../../state/i18n/actions';

class I18n extends React.Component {
  componentDidMount() {
    const { initLanguage } = this.props;

    initLanguage();
  }

  render() {
    const { children, language } = this.props;

    return <I18nLoader language={language}>{children}</I18nLoader>;
  }
}

function mapStateToProps(state) {
  return {
    language: state.i18n.localeId,
  };
}

const mapDispatchToProps = { initLanguage };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(I18n);
